import { VideoPostInput } from '../../templates/inputs/VideoPostInput';
import { isVideoPost } from '../PostTypes';
import { VideoPostData } from '../types/VideoPostData';
import { defineTemplate } from './TemplateUtils';

export const VideoMedium = defineTemplate(
    'Video',
    'Medium',
    VideoPostInput,
    () =>
        ({
            $type: 'Video',
            size: 'Medium',
        }) satisfies VideoPostData,
    isVideoPost,
);
export const VideoLarge = defineTemplate(
    'Video',
    'Large',
    VideoPostInput,
    () =>
        ({
            $type: 'Video',
            size: 'Large',
        }) satisfies VideoPostData,
    isVideoPost,
);
